export const issueOwner = {
    ALL: { value: 1, label: 'All' },
    PERSONAL: { value: 2, label: 'Personal' }
}